import { initializeApp, type FirebaseApp } from "firebase/app";
import { getAuth, onIdTokenChanged, type Auth } from "firebase/auth";
import { getConfig } from "@/config";

let appSingleton: FirebaseApp | null = null;
let authSingleton: Auth | null = null;

// Latest Firebase ID token, refreshed via onIdTokenChanged. Synchronous
// access is what lets `assetUrl(...)` be used inline in JSX (`<img src>`
// can't await), since browser image tags can't attach an Authorization
// header — the asset endpoint accepts the token via `?token=` instead.
let cachedIdToken: string | null = null;

export function getFirebaseAuth(): Auth {
  if (authSingleton) return authSingleton;
  const cfg = getConfig();
  appSingleton = initializeApp(cfg.firebase);
  authSingleton = getAuth(appSingleton);
  // Fires on sign-in, sign-out, and every silent token refresh (~hourly).
  onIdTokenChanged(authSingleton, async (user) => {
    cachedIdToken = user ? await user.getIdToken() : null;
  });
  return authSingleton;
}

export function getCachedIdToken(): string | null {
  return cachedIdToken;
}
